import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe994b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "login",
  class: "container"
}
const _hoisted_2 = { class: "card white" }
const _hoisted_3 = { class: "card-content black-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title" }, "Login", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-action" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Login")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
          class: "mt-5"
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            type: "text",
            class: "form-control",
            placeholder: "Username",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.username]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            type: "password",
            class: "form-control",
            placeholder: "Password",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.password]
          ]),
          _hoisted_5
        ], 32),
        _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
      ])
    ])
  ]))
}